import { setLabels } from "@shared/helpers/enum-helpers";

export enum OutboundLoadExceptionType {
  Crossdock = 1,
}

setLabels(OutboundLoadExceptionType);
